export default "__VITE_ASSET__BAj7ctoa__"